import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
//import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { AuthNoticeService, AuthService, Login } from '../../../../core/auth';
import { TranslateService } from '@ngx-translate/core';
import { finalize, takeUntil, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';


@Component({
  selector: 'kt-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit, OnDestroy {
  verifyForm: UntypedFormGroup;
  gCaptchaResponse: any;
  isCaptchaSelected: boolean = true;
  siteKey = environment.runtime.siteKey;
  loading = false;
  private unsubscribe: Subject<any>;
  private returnUrl: any;
  isRemember = false;
  recaptcha: boolean;
  isLogoAvailable: any;
  imagePaths = {
    uptimeLogoOriginal: "assets/media/logos/logo-loader-colour.svg"
  }

  /**
   * Component constructor
   *
   * @param router: Router
   * @param auth: AuthService
   * @param authNoticeService: AuthNoticeService
   * @param translate: TranslateService
   * @param store: Store<AppState>
   * @param fb: FormBuilder
   * @param cdr
   */
  constructor(private readonly router: Router,
    private readonly fb: UntypedFormBuilder,
    private readonly auth: AuthService,
    private readonly authNoticeService: AuthNoticeService,
    private readonly translate: TranslateService,
    private readonly store: Store<AppState>,
    private readonly route: ActivatedRoute,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.unsubscribe = new Subject();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/web/dashboard';
  }


  ngOnInit() {
    this.recaptcha = environment.runtime.recaptcha;
    this.isLogoAvailable = JSON.parse(localStorage.getItem('layoutConfig'))['logo'];
    if (sessionStorage.getItem('femail'))
      this.initResetForm();
    else
      this.router.navigateByUrl('/web/login');
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    this.authNoticeService.setNotice(null);
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
    this.loading = false;
  }
  initResetForm() {
    this.verifyForm = this.fb.group({
      email: [sessionStorage.getItem('femail'), Validators.compose([
        // Validators.required,
        Validators.email,
        Validators.minLength(3),
        Validators.maxLength(320)
      ]),
      ],
      otp: ['', Validators.compose([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(6)
      ]),
      ],

    });

  }
  onRememBerMe(e) {
    this.isRemember = e.checked;
  }
  /**
   * Form Submit
   */
  async submit() {

    const controls = this.verifyForm.controls;
    if (this.verifyForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }

    this.loading = true;

    const authData = {
      email: controls['email'].value,
      otp: +controls['otp'].value,
      'g-recaptcha-response': this.gCaptchaResponse
    };
    this.auth.verify(authData.email.toLowerCase(), authData.otp, this.isRemember, authData['g-recaptcha-response'])
      .pipe(tap((res: any) => {
        if (res.status == 200) {
          if (res.headers.get('x-auth-token')) {
            this.store.dispatch(new Login({ authToken: res.headers.get('x-auth-token') }));
          } else {
            if (environment.runtime.recaptcha)
              grecaptcha.reset()
            this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_RESET'), 'danger');
          }
        }
      }), takeUntil(this.unsubscribe),
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe();
  }
  resolved(e) {
    this.gCaptchaResponse = e
    this.isCaptchaSelected = e ? false : true;
  }

  /**
 * Checking control validation
 *
 * @param controlName: string => Equals to formControlName
 * @param validationType: string => Equals to valitors name
 */
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.verifyForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && control.touched;
    return result;
  }

}
